import type { CatalogSearchSuggestionModel } from '../catalog-search-suggestions.model';
import type { ProductBaseModel } from '../product/product.model';

// eslint-disable-next-line @typescript-eslint/typedef
export const TRACKING_AVAILABILITY = {
  available: 'verfügbar',
  notAvailable: 'nicht verfügbar',
} as const;

export type TrackingAvailability = typeof TRACKING_AVAILABILITY[keyof typeof TRACKING_AVAILABILITY];

export function toTrackingAvailability(isAvailable: boolean): TrackingAvailability {
  return isAvailable ? TRACKING_AVAILABILITY.available : TRACKING_AVAILABILITY.notAvailable;
}

export interface ProductTrackingModel {
  id: string;
  price: string | null;
  quantity: number;
  list?: string;
  position?: number;
  bundleID: string;
  bundleName: string;
  promotionType: string;
  originalPrice: number | '';
  availability?: TrackingAvailability;
}

export interface TrackingCatalogSearchSuggestionModel extends CatalogSearchSuggestionModel {
  type: 'suggestion';
  position: number;
  quantity: number;
}

export interface TrackingProductModel extends ProductBaseModel {
  type: 'product';
  position: number;
  quantity: number;
  availability?: TrackingAvailability;
  trackingList?: string;
}

export interface TrackingPartialProductModel {
  type: 'partialProduct';
  sku: string;
  position: number;
  quantity: number;
  salesUnitPrice?: number;
  name: string;
  availability?: TrackingAvailability;
  trackingList?: string;
}

export type TrackingProduct = TrackingProductModel | TrackingPartialProductModel | TrackingCatalogSearchSuggestionModel;
